import React from "react";
import { format, formatDistance } from "date-fns";
import { toPng, toJpeg } from "html-to-image";
import { jsPDF } from "jspdf";
import base64 from "base64-js";
import struct from "python-struct";
import { mean } from "simple-statistics";
import { Buffer } from "buffer";
import * as math from "mathjs";
import { toByteArray } from "base64-js";
import { unpack } from "python-struct";
import QRCode from "qrcode";

export const getColorClass = (value) => {
  if (value >= 0.8) return "color-green";
  if (value <= 0.3) return "color-red";
  return "color-amber";
};
export const getPositveColor = (value) => {
  if (value > 0) return "color-green";
  return "color-red";
};
export const getPercentage = (val) => {
  return parseInt(val * 100);
};
export const getBGColorClass = (value) => {
  if (value >= 80) return "bg-green bg-new-green";
  if (value <= 30) return "bg-red bg-new-red";
  return "bg-amber bg-new-orange";
};
export const sumItem = (items, prop) => {
  return items.reduce(function (a, b) {
    return a + b[prop];
  }, 0);
};

export const dateFormat = (value) => {
  var d = new Date(value),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
};

export const dateShortFormat = (value) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var d = new Date(value),
    month = "" + monthNames[d.getMonth()],
    day = "" + d.getDate();
  if (day.length < 2) day = "0" + day;
  return [day, month].join(" ");
};
export const dateOnlyFormat = (value) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var d = new Date(value),
    month = "" + monthNames[d.getMonth()],
    year = d.getFullYear(),
    day = "" + d.getDate();
  if (day.length < 2) day = "0" + day;
  return [day, month, year].join(" ");
};
export const removeTimeZone = (value) => {
  return value.replace("T", " ").replace("Z", "");
};
export const formatDateFull = (value) => {
  if (!value) return "-";
  value = new Date(value);
  // return format(new Date(value), "yyyy-MM-dd HH:mm");

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }
  return (
    [
      value.getFullYear(),
      padTo2Digits(value.getMonth() + 1),
      padTo2Digits(value.getDate()),
    ].join("-") +
    " " +
    [
      padTo2Digits(value.getHours()),
      padTo2Digits(value.getMinutes()),
      padTo2Digits(value.getSeconds()),
    ].join(":")
  );
};
// export const formatTimeOnly = (value) => {
//   value = new Date(value);
//   function padTo2Digits(num) {
//     return num.toString().padStart(2, "0");
//   }
//   return [
//     padTo2Digits(value.getHours()),
//     padTo2Digits(value.getMinutes()),
//     padTo2Digits(value.getSeconds()),
//   ].join(":");
// };
export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
export const formatTimestamp = (value) => {
  var datum = Date.parse(value);
  return datum / 1000;
};
export const Arrow = (value) => {
  if (value > 0) return <span style={{ color: "#45C0A5" }}>&#x25B2;</span>;
  if (value < 0) return <span style={{ color: "#FE8182" }}>&#x25BC;</span>;
  return <span style={{ color: "gray" }}>&#x25B6;</span>;
};
export const getColorForSeverity = (severity) => {
  if (severity === "Mild") return "#26CB9E";
  if (severity === "Severe") return "#E84B4B";
  return "#FFBD52";
};

export const getColors = [
  "#FFBE0B",
  "#FB5607",
  "#ff9900",
  "#FF006E",
  "#ff9999",
  "#ff00ff",
  "#9900ff",
  "#3A86FF",
  "#000099",
  "#0EAD69",
  "#00cc00",
  "#0BDDFF",
];
export const SeverityColors = {
  healthy: "#AFEACD",
  mild: "#85B7F3",
  moderate: "#FFBE7E",
  critical: "#FF779C",
  unknown: "#9379FF",
  blank: "#CDCED0",
};
export const SeverityColorsSoft = {
  open: "#FF779C",
  progress: "#FCEAB7",
  invalid: "#a8a8a8",
  closed: "#CDCED0",
};

export const anomaly_scale = {
  critical: 1,
  mild: 0.2,
  moderate: 0.5,
  unknown: 0.75,
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const upperCase = (string) => {
  return string.toUpperCase();
};

//check NaN return "-"
export const checkNaN = (value) => {
  if (isNaN(value)) {
    return 0;
  } else {
    return value;
  }
};
export const getSeverity = (string) => {
  if (string === "Anomaly" || string === "Anamoly") {
    return "moderate";
  }
  if (string === "Not Sure") {
    return "mild";
  }
  return null;
};
export function getBrowserVisibilityProp() {
  if (typeof document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    return "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    return "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitvisibilitychange";
  }
}

export function getBrowserDocumentHiddenProp() {
  if (typeof document.hidden !== "undefined") {
    return "hidden";
  } else if (typeof document.msHidden !== "undefined") {
    return "msHidden";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitHidden";
  }
}

export function getIsDocumentHidden() {
  return !document[getBrowserDocumentHiddenProp()];
}

export const downloadJPG = (id, filename = "download") => {
  toJpeg(document.getElementById(id), { quality: 0.95 }).then(function (
    dataUrl
  ) {
    var link = document.createElement("a");
    link.download = "my-image-name.jpeg";
    link.href = dataUrl;
    link.click();
  });
};

export const cropImage = (
  imgUri,
  width = 400,
  height = 300,
  xstart = 0,
  ystart = 0,
  callback
) => {
  try {
    console.log("Values in crop", width, height);
    let resize_canvas = document.createElement("canvas");
    let orig_src = new Image();
    orig_src.src = imgUri;
    orig_src.onload = function () {
      resize_canvas.width = width;
      resize_canvas.height = height;
      let cnv = resize_canvas.getContext("2d");
      cnv.drawImage(
        orig_src,
        xstart,
        ystart,
        width,
        height,
        0,
        0,
        width,
        height
      );
      let newimgUri = resize_canvas.toDataURL("image/png").toString();
      callback(newimgUri);
    };
  } catch (e) {
    console.log("Couldn't crop image due to", e);
    window.alert("Couldn't crop image due to", e);
    callback(imgUri);
  }
};

export const downloadPDF = (id, filename = "download") => {
  toPng(document.getElementById(id), { quality: 0.95 }).then(function (
    dataUrl
  ) {
    console.log({ dataUrl });
    // split or cut the base64 image into multiple image per A4 size
    const paperHeight = 2100;
    const paperWidth = 1500;
    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(dataUrl);
    const imgHeight = imgProps.height;
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    const totalPDFPages = Math.ceil(imgHeight / paperHeight);
    const images = [];
    console.log({ totalPDFPages, imgProps });
    for (let i = 0; i < totalPDFPages; i++) {
      cropImage(
        dataUrl,
        paperWidth,
        paperHeight,
        0,
        i * paperHeight,
        (newimgUri) => {
          images.push(newimgUri);
          pdf.addImage(newimgUri, "PNG", 0, 0, pdfWidth, pdfHeight);
        }
      );
      pdf.addPage();
    }
    console.log({ images });
    // pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
    // pdf.addPage();
    // pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${filename}.pdf`);
  });
};

export const createTimeArray = (interval = 60) => {
  var times = [];
  var start = new Date(0, 0, 0, 0, 0); // Start time: 00:00
  var end = new Date(0, 0, 0, 23, 59); // End time: 23:45

  while (start <= end) {
    var hours = start.getHours().toString().padStart(2, "0");
    var minutes = start.getMinutes().toString().padStart(2, "0");
    var time = hours + ":" + minutes;
    times.push(time);

    start.setMinutes(start.getMinutes() + interval); // Increment by {interval} minutes
  }

  return times;
};

export const getTimeDomainData = (payload) => {
  const bdata = base64.toByteArray(payload);
  const coef = 0.01497;
  const freq = 20000;
  const count = bdata.length / 2;
  const shortArray = struct.unpack(
    ">=h".repeat(bdata.length / 2),
    Buffer.from(bdata)
  );
  const fData = shortArray.map((item) => item * coef);
  const meanValue = mean(fData);
  const centeredData = fData.map((item) => item - meanValue);
  const xData = new Array(Math.floor(bdata.length / 2))
    .fill(0)
    .map((_, index) => (index * 1) / freq / 2.56);

  return {
    x: xData,
    y: centeredData,
    type: "scatter",
    mode: "lines",
  };
};

export const getFreqDomainData = (payload) => {
  const bdata = base64.toByteArray(payload);
  const coef = 0.01497;
  const freq = 20000;
  const count = bdata.length / 2;
  const shortArray = struct.unpack(
    ">=h".repeat(bdata.length / 2),
    Buffer.from(bdata)
  );
  const fData = shortArray.map((item) => item * coef);
  const meanValue = mean(fData);
  const centeredData = fData.map((item) => item - meanValue);
  const xData = new Array(Math.floor(bdata.length / 2))
    .fill(0)
    .map((_, index) => (index * 1) / freq / 2.56);

  const time_step = 1 / freq;

  const frequencies = math
    .fft(fData)
    .map((_, index) => index / (fData.length * time_step));
  const magnitude = frequencies.map((_, index) => math.abs(fData[index]));

  const plotData = {
    x: frequencies.slice(0, frequencies.length / 2.56),
    y: magnitude.slice(0, magnitude.length / 2),
    type: "scatter",
    mode: "lines",
  };

  return plotData;
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  return format(new Date(value), "dd/MM/yyyy HH:mm");
};

export const formatDateOnly = (value) => {
  if (!value) return "-";
  return format(new Date(value), "dd/MM/yyyy");
};

export const formatDateYMD = (value) => {
  if (!value) return "-";
  return format(new Date(value), "yyyy-MM-dd");
};

export const formatTimeOnly = (value) => {
  if (!value) return "-";
  return format(new Date(value), "HH:mm:ss");
};

export const dateToToday = (value) => {
  return formatDistance(new Date(value), new Date(), { addSuffix: true });
};

export const renderImage = (path) => {
  return process.env.REACT_APP_API_URL + "/" + path;
};

export const getFileUrl = (path) => {
  return process.env.REACT_APP_API_URL + "/machine/attachment/" + path;
};

export const printLocation = (name) => {
  if (!name) return;
  if (name) {
    if (name.includes("_")) return name.split("_")[1];
    else return name;
  }
};
export const decodeBase64ToDoubleList = (encodedData) => {
  const binaryData = toByteArray(encodedData);

  // Unpack the binary data to obtain the list of double values
  const numDoubles = binaryData.length / 8; // Assuming 8 bytes per double

  const formatString = ">" + "d".repeat(numDoubles);
  const doubleList = unpack(formatString, Buffer.from(binaryData));
  console.log({ doubleList });
  return doubleList;
};

export function generateLocationToArray(location, locationNameArr) {
  locationNameArr.push(location.location_name);
  if (location.parent_location) {
    generateLocationToArray(location.parent_location, locationNameArr);
  }
}

export const Loader = ({ loading, children }) => {
  return (
    <div>
      {loading ? (
        <div className="text-center">
          <div className="spinner-grow text-primary"></div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export const printDate = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    // it is a date
    if (isNaN(date)) {
      // d.getTime() or d.valueOf() will also work
      return "-";
    } else {
      // date object is valid
    }
  } else {
    return "-";
  }
  if (!date) return "-";
  const dateSplit = date.split("-");
  const day = dateSplit[0] ? dateSplit[0] : "";
  const month = dateSplit[1]
    ? format(new Date().setMonth(dateSplit[1] - 1), "MMMM")
    : "";
  const year = dateSplit[2] ? dateSplit[2] : "";
  return day + " " + month + " " + year;
};

export const machineHealthColor = (value) => {
  if (value === "Acceptable") return "rgb(175,234,205)";
  if (value === "Critical") return "rgb(255,119,156)";
  if (value === "Alert") return "rgb(255,190,127)";
  if (value === "Observe") return "rgb(249,220,142)";
};

export const findNearestValue = (arr, x) => {
  let low = 0;
  let high = arr.length - 1;

  while (low < high) {
    const mid = Math.floor((low + high) / 2);

    if (arr[mid] === x) {
      return arr[mid];
    } else if (arr[mid] < x) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }

  // After the loop, low and high will converge to the closest element
  if (low === 0) {
    return arr[0];
  }
  if (low === arr.length) {
    return arr[arr.length - 1];
  }

  // Compare the closest two elements and return the nearest one
  if (Math.abs(arr[low] - x) < Math.abs(arr[low - 1] - x)) {
    return arr[low];
  } else {
    return arr[low - 1];
  }
};

export const formatNumber = (value, fixed = 2) => {
  if (value === null || value === undefined) return "-";
  value = parseFloat(value).toFixed(fixed);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const getStatusColor = (status) => {
  const color = {
    Open: "danger",
    "In Progress": "warning",
    "On Hold": "primary",
    Completed: "default",
  };
  return color[status];
};

export const getRequestStatusColor = (status) => {
  const color = {
    Pending: "warning",
    Approved: "theme",
    Declined: "danger",
  };
  return color[status];
};

export const getEmptyField = (payload, mandatory) => {
  const emptyField = [];
  mandatory.forEach((m) => {
    if (!payload[m]) {
      emptyField.push(m);
    } else {
      if (typeof payload[m] == "string") {
        if (!payload[m].trim()) {
          emptyField.push(m);
        }
      }
    }
  });
  return emptyField;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const generateAssetQRCodeDataURL = async (value) => {
  try {
    const img = await QRCode.toDataURL(
      window.location.protocol +
        "//" +
        window.location.host +
        "/asset/qrcode/" +
        value,
      {
        scale: 8,
      }
    );
    return img;
  } catch (err) {
    console.error("Error generating QR code", err);
    return "";
  }
};